// Two-Track §M2 · Read-only shared discovery view. Auth-free — token
// carries all authorization. Renders the same DiscoverySummary as the
// public discover page, plus a "shared by" watermark.
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

import { DiscoverySummary } from "../components/DiscoverySummary";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api/brand-os";

export default function SharedDiscoverySummary() {
  const { shareToken } = useParams();
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.get(`${API}/genesis/shared/${shareToken}`);
        if (cancelled) return;
        setSummary(r.data);
        setError(null);
      } catch (e) {
        if (cancelled) return;
        setError(e?.response?.data?.detail?.reason || e?.response?.data?.detail?.message || e.message);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [shareToken]);

  return (
    <div style={{ minHeight: "100vh", background: "#f5f1e8", padding: "56px 24px" }}>
      <div style={{ maxWidth: 820, margin: "0 auto" }}>
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 11, letterSpacing: 2.8, textTransform: "uppercase", color: "#8a6a1f" }}>
            Brand OS · Shared discovery
          </div>
          <h1
            style={{ fontFamily: "'DM Serif Display', serif", fontSize: 30, margin: "6px 0 6px", color: "#1e1b16" }}
            data-testid="shared-discovery-title"
          >
            A teammate shared their Genesis discovery with you.
          </h1>
          <p style={{ color: "#6b6558", margin: 0, fontSize: 14 }}>
            This is a read-only view of what Genesis learned about their business. Nothing here is treated as approved truth — every claim is provisional and citable back to a page on their site.
            {summary?.shared_expires_at ? (
              <span style={{ marginLeft: 6, fontSize: 12, color: "#8a6a1f" }} data-testid="shared-discovery-expires">
                · Link expires {new Date(summary.shared_expires_at).toLocaleDateString()}
              </span>
            ) : null}
          </p>
        </div>

        {error ? (
          <div className="bo-card" data-testid="shared-discovery-error" style={{ borderColor: "rgba(179, 74, 74, 0.4)" }}>
            <div className="bo-eyebrow" style={{ color: "#b34a4a" }}>This share link isn&rsquo;t working</div>
            <p style={{ margin: "6px 0 0", fontSize: 13, color: "#6b6558" }}>
              {error === "share_invalid_or_expired"
                ? "The link may have expired, been revoked, or never existed. Ask the person who shared it for a fresh one."
                : String(error)}
            </p>
          </div>
        ) : null}

        <DiscoverySummary summary={summary} testIdPrefix="shared-discovery-summary" />
        {/* HIDDEN 2026-11-01: the "Try Brand OS on your URL" CTA pointed at the
            public trial, which is not ready (see frontend/hidden-sections/). */}
      </div>
    </div>
  );
}
